module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAA1ElEQVQ4T4WS4RXBQBCEJ5WgElSCSlAJKkEl6MT78m7yJuci9yvZvW93dvY6jc9L0k3SqYo3f7uIAp4lLUtstoBhg9cAH5J2kjZTaoBr0GIukj5lBKsYqQFuJRJ0sZ97lp2JFtgskIZh1DGkThnOmCuSCf/rmJ0Xkg4J0/U+s2NGA2Sdb8OsAtBrssMp2yAdB3/SMMupXU1wZJxhZHvfXEbJs9wcZgwpex5QwgAUYSYAxuGV8db5tqIelLRNtykM7CTzAXMMYlQP1qtKg9y1Nm1tkMQXEy04T9obeRgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gps.png
// module id = SadT
// module chunks = 2